<template>
	<b-modal
		ref="eventsByTournamentDetailsModal"
		hide-footer
		centered
		no-close-on-backdrop
		size="xlg"
		title-class="w-100 d-flex justify-content-between"
		@hidden="handleCloseModal"
	>
		<template #modal-title>
			<div class="d-flex flex-column flex-md-row w-100 justify-content-between">
				<span class="d-inline h4 mb-25 mt-25">Fechas de {{ info.tournament }}</span>
			</div>
		</template>
		<b-table-simple sticky-header="60vh">
			<b-thead class="text-center" :key="events.length">
				<b-tr>
					<b-th class="text-nowrap bg-head-event">Fecha</b-th>
					<b-th class="text-nowrap bg-head-event">Campeonato</b-th>
					<b-th class="text-nowrap bg-head-event">Coliseo</b-th>
					<b-th class="text-nowrap bg-head-event">Etapa</b-th>
					<b-th class="text-nowrap bg-head-event">Tipo</b-th>
					<b-th class="text-nowrap bg-head-event">Metodo</b-th>
					<b-th class="text-nowrap bg-head-event">Peso (KG)</b-th>
					<b-th class="bg-head-event">Frentes</b-th>
					<b-th class="bg-head-event">Resultados</b-th>
				</b-tr>
			</b-thead>
			<b-tbody class="text-center">
				<b-tr v-for="row in events" :key="`event-${row.id}`">
					<b-td>
						<p class="mb-0">{{ row.date | myGlobalDayShort }}</p>
					</b-td>
					<b-td>
						<div class="d-flex align-items-center justify-content-center gap-x-2">
							<div>
								<ViewImage
									v-b-tooltip.hover
									:title="row.avatar_alias"
									:specimen="{
										id: 1,
										url: row.url_image,
									}"
								/>
							</div>
							<span>{{ row.tournament }}</span>
						</div>
					</b-td>

					<b-td>
						{{ row.coliseum }}
						<br />
						<span style="font-size: 0.8rem">
							<b>{{ row.coliseum_city }}</b>
						</span>
					</b-td>
					<b-td class="text-nowrap">
						<b-badge :style="{ background: row.stage_color }">
							{{ row.stage }}
						</b-badge>
					</b-td>
					<b-td>{{ row.type }}</b-td>
					<b-td>
						<div style="display: flex; justify-content: center; gap: 0.2rem">
							<div>
								{{ row.method }}
							</div>
						</div>
					</b-td>
					<b-td>
						{{ row.weight == "" || row.weight == null || row.weight == "null" ? "---" : row.weight }}
					</b-td>
					<b-td>
						<p class="mb-0 ml-1 mr-1 font-weight-bolder">{{ row.fronts }}</p>
					</b-td>
					<b-td>
						<b-button
							class="position-relative w-100 mb-1"
							:variant="
								parseFloat(row.fronts_percentage) == 0
									? 'secondary'
									: parseFloat(row.fronts_percentage) == 100
									? 'success'
									: parseFloat(row.fronts_percentage) > 0
									? 'warning'
									: 'secondary'
							"
							size="sm"
							:disabled="row.specimens.registered !== null && row.specimens.registered < 1"
							@click="handleResultsClick(row)"
						>
							<FeatherIcon icon="EyeIcon" />
						</b-button>
					</b-td>
				</b-tr>
				<b-tr v-if="events.length == 0">
					<b-td colspan="10">No hay registros para mostrar</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<ResultsModal
			:tab="tab"
			@refresh="getRows"
			:show="results.show"
			:info="results.info"
			isFromEventDetails
			@closing="results.show = !results.show"
		/>
	</b-modal>
</template>

<script>
import ViewImage from "@/components/commons/ViewImage.vue"
import tournamentService from "@/services/tournament/default.service"
export default {
	components: {
		ViewImage,
		ResultsModal: () => import("@/views/amg/tournaments/v2/components/ResultsModal.vue"),
	},
	props: {
		info: Object,
	},
	name: "EventsByTournamentDetailsModal",
	data: () => ({
		results: {
			show: false,
			info: {},
		},
		tab: 0,
		events: [],
	}),
	methods: {
		handleResultsClick(row) {
			this.results.info = row
			this.results.show = !this.results.show
		},
		handleCloseModal() {
			this.$emit("close")
		},
		async getRows() {
			const params = {
				tournament_id: this.info.tournament_id,
			}
			const { data } = await tournamentService.getEventsByTournamentDetails(params)
			this.events = data.data
		},
	},
	async mounted() {
		await this.getRows()
		this.$refs["eventsByTournamentDetailsModal"].toggle()
	},
}
</script>

<style lang="scss" scoped></style>
